<script lang="ts">
    export let height = "h-6";
    export let width = "w-6";
    export let strokeColor = "stroke-mdark";
    export let fillColor = "fill-transparent";
    export let hover = "group-hover/btn-follow:fill-mblue group-hover/btn-follow:stroke-mblue";
    export let strokeWidth = "1.5";
    export let classList = "aspect-ratio transition-all";
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon {height} {width} {strokeColor} {fillColor} {classList}"
    stroke-width={strokeWidth}
    stroke-linecap="round"
    stroke-linejoin="round"
    viewBox="0 0 24 24"
>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M7 5a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z" class={hover} />
    <path d="M5 7v9.5a3.5 3.5 0 0 0 7 0v-9a3.5 3.5 0 0 1 7 0v13.5" />
    <path d="M16 18l3 3l3 -3" class={hover} />
</svg>
